<template>
    <div class="profile-order-table">
        <orders :orderList="orders" v-if="orders.length > 0"></orders>
        <div class="empty" v-else>
            <img src="../../../assets/profile/empty-cart.png" alt="">
            <router-link :to="{name:'FooterShop'}">
                <p>
                    <Button type="text" style="font-size:16px;">{{$t('shopping_card_go_to_shopping')}} <Icon type="chevron-right"></Icon></Button>
                </p>
            </router-link>
            <Spin size="large" fix v-if="spinShow"></Spin>
        </div>
    </div>
</template>
<script>
    import orderGroup from '../Common/OrderGroup.vue'
    import orderList from '../Common/OrderList.vue'
    import Signature from '../../../lib/Signature'
    import orders from '../Common/Orders.vue'

    export default {
        data () {
            return {
                spinShow: false,
                guessList: [],
                orders: [],
            }
        },
        components: {
            'order-group': orderGroup,
            'order-list': orderList,
            orders
        },
        computed: {
            totalPrice () {
                let temp = 0
                for (let item of this.goods) {
                    temp += parseInt(item.price) * item.num
                }
                return temp
            },
            selectedNum () {
                return this.goods.length
            }
        },
        methods: {
            refreshGoods () {
//        猜你喜欢,删除下面的代码,使用后台数据
                this.guessList.sort(() => Math.random() > 0.5 ? -1 : 1)
            },
            fetchData () {
                let data = {}
                this.spinShow = true
                const module = 'index.php/index.php/index/goods/guessyoulike'
                data.sub_time = Signature.timestamp()
                data.user_id = this.Local.getUserId()
                data.lang = this.$i18n.locale
                data.content = this.$route.query.q
                data.token = this.Local.getUserToken()
                data.sign = Signature.create(module, data.sub_time)
                data.type = 1
                this.$http.get(process.env.BASEURL + module, {
                    params: data
                })

                .then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        this.spinShow = false
                        this.orders = resp.data.data.order_list
                    }
                }.bind(this))
            }
        },
        watch: {
            '$route': function (to, from) {
                this.fetchData()
            }
        },

        created () {
            this.fetchData()
        }
    }
</script>
<style lang="scss">
    .empty {
        text-align: center;
        font-size: 16px;
        padding: 30px;
    }



    .prifile-order-total {
        font-size: 16px;
        letter-spacing: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .order-total-left, .order-total-right {
            display: flex;
            align-items: center;
        }
        .order-calculate {
            border-left: 2px solid #5E6D82;
            padding: 0 17px;
            line-height: 2;
            font-size: 16px;
            color: #5E6D82;
            letter-spacing: 0;
            & > span {
                color: #0084FF;
            }
        }
        .order-subtotal {
            color: #5E6D82;
            margin-right: 20px;
            span {
                font-size: 16px;
                letter-spacing: 0;
            }
            .total-price {
                font-size: 24px;
            }
        }
    }

    .text-primary {
        color: #0084FF;
    }
</style>



// WEBPACK FOOTER //
// Ongoing.vue?e551ffa2